import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dochub': {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M397.9 160h-141.9v-140.4zM304 192h96v126.1c0 129.3-70.3 193.9-210.8 193.9h-189.2v-512h189.2c12.2 0 23.7 1.1 34.6 3.3v84c-10-1.7-21.1-2.5-33.1-2.5h-94.7v337.3h94.7c76.8 0 113.3-33.3 113.3-100.1v-130z'
      }
    ]
  }
})
